export const menu = [
  {
    id: 'dashboard',
    name: 'Dashboard',
    icon: 'dashboard',
    link: '/dashboard',
    color: 'primary',
    accessControlName: 'dashboard',
    submenu: []
  },
  {
    id: 'orders',
    name: 'Pedidos',
    icon: 'orders',
    link: '/orders',
    color: 'primary',
    accessControlName: 'pedidos',
    submenu: []
  },
  {
    id: 'my-store',
    name: 'Cupons',
    icon: 'cupom',
    link: '/settings',
    color: 'primary',
    accessControlName: 'cupons',
    submenu: [
      {
        id: 'settings',
        name: 'Consulta',
        link: '/cupom-consulta',
        color: 'primary'
      },
      {
        id: 'settings',
        name: 'Cadastro',
        link: '/cupom-cadastro',
        color: 'primary'
      }
    ]
  },
  {
    id: 'clients',
    name: 'Clientes',
    icon: 'clients',
    link: '/clients',
    color: 'primary',
    accessControlName: 'clientes',
    submenu: []
  },
  {
    id: 'products',
    name: 'Cardápio',
    icon: 'products',
    link: '/products',
    color: 'primary',
    accessControlName: 'cardapio',
    submenu: []
  },
  {
    id: 'replicate-menu',
    name: 'Replicar Cardápio',
    icon: 'replicateMenu',
    link: '/replicate-menu',
    color: 'primary',
    accessControlName: 'replicaCardapio',
    submenu: []
  },
  {
    id: 'my-store',
    name: 'Minha Loja',
    icon: 'store',
    link: '/settings',
    color: 'primary',
    accessControlName: 'minhaLoja',
    submenu: [
      {
        id: 'openportaladmin',
        name: 'Portal Administrativo',
        link: 'https://www.voceqpad.com.br/administrativo',
        color: 'primary'
      },
      {
        id: 'openinghours',
        name: 'Horário de funcionamento',
        link: '/opening-hours',
        color: 'primary'
      },
      {
        id: 'layout',
        name: 'Layout',
        link: '/layout',
        color: 'primary',
        multistoreOnly: true
      },
      {
        id: 'settings',
        name: 'Configurações',
        link: '/settings',
        color: 'primary'
      }
    ]
  }
];
